import React from "react";
import { Link } from 'react-router-dom';

const steps = [
    {
        title: "1. Wybierz znicz",
        description: "Wybierz jeden z naszych pięknych, wirtualnych zniczy.",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" aria-hidden="true">
                <path d="M12 3c-1.8 3.2 1.4 4.2 0 7.5-1.4-3.3 1.8-4.3 0-7.5Z"/>
                <rect x="7" y="11" width="10" height="9" rx="2"/>
            </svg>
        ),
    },
    {
        title: "2. Dodaj wspomnienie",
        description:
            "Podpisz go imieniem bliskiej osoby i dodaj kilka słów od serca.",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" aria-hidden="true">
                <path d="M4 19c6-4 10-6 16-10"/>
                <path d="M7 6a3 3 0 0 1 5 2c0 2-2 4-5 6-3-2-5-4-5-6a3 3 0 0 1 5-2Z"/>
                <path d="M15 18l2 2 4-4"/>
            </svg>
        ),
    },
    {
        title: "3. Podziel się światłem",
        description:
            "Udostepnij znicz, by inni mogli zobaczyć Twoje piękne wspomnienie.",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" aria-hidden="true">
                <path d="M4 12v-2a2 2 0 0 1 2-2h6"/>
                <path d="M12 4l4 4-4 4"/>
                <rect x="4" y="14" width="16" height="6" rx="2"/>
            </svg>
        ),
        cta: true,
    },
];

const testimonials = [
    {
        image: "/candles/ciepło-chryzantem.jpg",
        alt: "Wirtualny znicz stworzony przez AI",
        dedication: "Dla Ukochanej Mamy - córcia Ania",
        note: "Tęsknię za Twoimi radami, bardzo by mi się teraz przydały...",
    },
    {
        image: "/candles/trójpłomień-nadziei.jpg",
        alt: "Wirtualny znicz stworzony przez AI",
        dedication: "Pamięci Dziadka Jana - wnuk Piotr",
        note: "Twoje historie żyją w nas. Świetnie się tego słuchało.",
    },
    {
        image: "/candles/czerwień-serca.jpg",
        alt: "Wirtualny znicz stworzony przez AI",
        dedication: "Naszej Przyjaciółce, Zawsze w Sercach",
        note: "Tęsknimy za Twoimi żartami, za szybko odeszłaś...",
    },
    {
        image: "/candles/vintage.jpg",
        alt: "Wirtualny znicz stworzony przez AI",
        dedication: "Dla Taty - Syn Michał",
        note: "Nauczyłeś mnie odwagi. Ten płomień jest dla Ciebie.",
    },
];

function LandingPage({children}) {
    return (
        <>
            <header className="landing-hero">
                <div className="landing-backdrop" aria-hidden="true"/>
                <div className="landing-overlay" aria-hidden="true"/>
                <div className="landing-hero-content container">
                    <h1>Pamięć, która trwa.</h1>
                    <p>
                        Zapal wirtualny znicz i pokaż, że Twoi bliscy są zawsze w Twoim sercu.
                    </p>
                    <p className="landing-subline">
                        Światło, które nigdy nie gaśnie - dla tych, którzy już odeszli.
                    </p>
                    <div className="landing-cta">
                        <a
                            href="#tribute-creator"
                            className="btn"
                            aria-label="Zapal Wirtualny Znicz Pamięci"
                        >
                            Chcę zapalić Wirtualny Znicz
                        </a>
                    </div>
                </div>
            </header>

            <section id="jak-to-dziala">
                <div className="container">
                    <h2>To bardzo proste - wystarczą 3 kroki:</h2>
                    <div className="landing-steps" role="list">
                        {steps.map((step) => (
                            <div className="landing-step" role="listitem" key={step.title}>
                                {React.cloneElement(step.icon, {stroke: "currentColor"})}
                                <p>
                                    <strong>{step.title}:</strong> {step.description}
                                </p>
                                {step.cta && (
                                    <div className="landing-step-cta">
                                        <a
                                            href="#tribute-creator"
                                            className="btn"
                                            aria-label="Przejdz do kreatora wirtualnych zniczy"
                                        >
                                            Chcę zapalić Wirtualny Znicz
                                        </a>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section aria-labelledby="proof-title">
                <div className="container">
                    <h2 id="proof-title">
                        Już tysiące osób pokazuje, że pamięta o swoich bliskich.
                    </h2>
                    <div
                        className="landing-carousel-wrap"
                        aria-label="Przykładowe wirtualne znicze"
                    >
                        <div className="landing-track" aria-live="off">
                            {[...testimonials, ...testimonials].map((entry, index) => (
                                <div
                                    className="landing-card"
                                    key={`${entry.dedication}-${index}`}
                                >
                                    <div className="landing-card-image">
                                        <img src={entry.image} alt={entry.alt}/>
                                    </div>
                                    <p>{entry.dedication}</p>
                                    <div className="landing-note">{entry.note}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="landing-cta-section">
                <div className="container">
                    <h2>
                        Twoja pamięć jest najważniejsza. Stwórz wirtualny znicz.
                    </h2>
                </div>
            </section>

            {children && (
                <section className="landing-generator-section">
                    <div className="container">{children}</div>
                </section>
            )}
        </>
    );
}

export default LandingPage;
